/* eslint-disable */
// useUserPermissionsRealtime — reactive access sync (Access-engine Step 1).
//
// When a user_portal_permissions row changes, invalidate the current user's
// ['portal-permissions'] query so the nav / hub / (later) route gates reflect the
// grant/revoke WITHOUT a re-login. Supabase Realtime respects RLS on postgres_changes,
// so a non-admin only receives events for THEIR OWN rows (own-or-admin SELECT) —
// exactly the rows that gate them; admins receive all. RLS still enforces the actual
// access, so a brief pre-refetch window is a UI-freshness concern, not a security hole.
//
// Mount ONCE near the other realtime hooks in App.js (post-auth). Mirrors the
// PermissionsPanel / useAccessControlData subscriptions, but targets the consuming
// hook (usePortalPermissions) that drives the affected user's own UI.
import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { supabase } from '../supabase';

export function useUserPermissionsRealtime() {
  const qc = useQueryClient();
  useEffect(() => {
    const ch = supabase
      .channel('user-perms-sync')
      .on('postgres_changes', { event: '*', schema: 'public', table: 'user_portal_permissions' }, () => {
        qc.invalidateQueries({ queryKey: ['portal-permissions'] });
      })
      .subscribe();
    return () => { supabase.removeChannel(ch); };
  }, [qc]);
}
